import { useSyncExternalStore } from 'react';

/** Tailwind's `lg` breakpoint. The sidebar and the two-column hubs start here. */
const DESKTOP_QUERY = '(min-width: 1024px)';

function subscribe(onChange: () => void) {
  const query = window.matchMedia(DESKTOP_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

const snapshot = () => window.matchMedia(DESKTOP_QUERY).matches;

/**
 * True at desktop widths. Hubs that compose different panels per layout use this
 * rather than rendering both trees and hiding one with CSS: the panels fire mount
 * effects (analytics events, the once-a-day guidance practice) that a hidden twin
 * would fire a second time.
 */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
